import { render, staticRenderFns } from "./CenterRegistration.vue?vue&type=template&id=13dd5669"
import script from "./CenterRegistration.vue?vue&type=script&lang=js"
export * from "./CenterRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports